<script setup lang="ts">
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { GpCard } from '@gportal/uikit';
import {
  type OperatingSystem,
  OperatingSystemFamily,
} from 'gpcore-grpc/gpcore/api/cloud/v1/image_pb';
import { computed } from 'vue';
import { toImageSrc } from 'gpcore-apikit/lib/fileHelper';
import type { Flavour } from 'gpcore-grpc/gpcore/api/cloud/v1/flavour_pb';
import { faCircleQuestion } from '@fortawesome/pro-solid-svg-icons';
import useGlobalConfig from '@panel/composables/useGlobalConfig';

const props = withDefaults(
  defineProps<{
    os: OperatingSystem;
    flavour?: Flavour; // flavour is optional because reinstall do not have a flavour set
    isSelected?: boolean;
    hasSplaLicense?: boolean;
    isInstalled?: boolean;
  }>(),
  {
    flavour: null,
    isSelected: false,
    hasSplaLicense: false,
  },
);

const { docs } = useGlobalConfig();

const emit = defineEmits<{ (e: 'osSelected') }>();

const isWindows = computed(() => props.os.family === OperatingSystemFamily.WINDOWS);

const handleClick = () => {
  emit('osSelected');
};
</script>

<template>
  <GpCard
    :active="isSelected"
    :enlarge-on-hover="false"
    :class="{ 'tw-cursor-pointer': !isSelected }"
    :aria-selected="isSelected"
    @click="handleClick"
  >
    <div class="tw-flex tw-h-full tw-items-center tw-p-4">
      <div class="tw-w-full">
        <img
          v-if="os.icon"
          :alt="`${os.name} icon`"
          class="tw-mb-1 tw-mr-4 tw-inline tw-h-6"
          :src="toImageSrc(os.icon)"
        />
        <FontAwesomeIcon v-else-if="isWindows" :icon="['fab', 'windows']" class="tw-mr-4" />
        <FontAwesomeIcon v-else :icon="['fab', 'linux']" class="tw-mr-4" />
        <strong class="tw-text-xl">{{ os.name }}</strong>
        <br />
        <small
          v-if="hasSplaLicense && flavour?.windowsMonthlyFee"
          class="tw-text-sm tw-text-gp-rhino"
        >
          + {{ flavour.windowsMonthlyFee.formatted }} / Month

          <a :href="`${docs.url}/guides/windows-licensing`" target="_blank">
            <FontAwesomeIcon :icon="faCircleQuestion" class="tw-ml-1 tw-text-gp-rhino" />
          </a>
        </small>
      </div>
    </div>
  </GpCard>
</template>
